export type AnalysesLpuSortValue = 'recommend' | 'name'

export type AnalysesLpuSortItem = {
  name: string
  value: AnalysesLpuSortValue
}

export const ANALYSES_LPU_DEFAULT_SORT: AnalysesLpuSortValue = 'recommend'

export const ANALYSES_LPU_SORT_ITEMS: AnalysesLpuSortItem[] = [
  { name: 'По рекомендуемым', value: 'recommend' },
  { name: 'По названию', value: 'name' },
]

export function getAnalysesLpuSortLabel(value?: AnalysesLpuSortValue): string {
  return ANALYSES_LPU_SORT_ITEMS.find(item => item.value === value)?.name
    ?? ANALYSES_LPU_SORT_ITEMS[0].name
}
